/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_Preview_RangeInputs */



/**
* | output |
* | --- |
* | "This week" |
*
* @param {Onboarding_First_Meeting_Preview_RangeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_preview_range = /** @type {((inputs?: Onboarding_First_Meeting_Preview_RangeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_Preview_RangeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze week")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette semaine")
	return /** @type {LocalizedString} */ ("This week")
});